import listComponent from '@/util/proto/listComponent'

const type = [
  {value:0 , label:'限时预警'},
  {value:1 , label:'超时预警'},
]

  // '$fenceType':[
  //   { value: 0, label: '禁行区围栏' },
  //   { value: 1, label: '企业网点考勤围栏' },
  //   { value: 2, label: '工作区围栏' },
  //   { value: 3, label: '停放区围栏' },
  // ],

const typeIcon = [
  {value:0 , label:'error'},
  {value:1 , label:'default'},
  {value:2 , label:'success'},
  {value:3 , label:'warning'},
]
export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        {
          title: '时间',
          key: 'alarmTimeText',
          width: 160,
          // sortable:true,
        },
        {
          title: '姓名',
          key: 'driverName',
          width: 100,
        },
        
        {
          title: '联系电话',
          key: 'driverPhone',
          width: 120,
        },
        {
          title: '车辆编号',
          key: 'carNo',
          width: 90,
        },
        {
          title: '围栏名称',
          key: 'gfName',
          width: 100,
        },
        {
          title: '预警类型',
          key: 'gfTypeText',
          width: 100,
        },
        {
          title: '预警地点',
          key: 'alarmAddrDetail',
          minWidth: 100,
        },
      ],
      data: [],
      options:{},
      visible:false,
    }
  },


  methods: {

    init(options) {
      this.options = options
      this.visible = true
      this.search()
    },
    search(){

      let params = { search:this.options || {}, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true

      this.$request.fenceAlarms(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , { 'alarmTime':'datetime' , gfType:'fenceType','gfType:typeIcon':typeIcon})
        this.page.total = resp.data.total
      })
    },
  },

  render(){
    const data = this.data || {}

    const title = '违法信息'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />

      </sl-side-panel>
    )
  }
}
